<template>
  <div>
    <div class="inquiry-table scroll_bar_beautify_ff">
      <data-table
        v-if="!loading"
        ref="dragTable"
        class="inquiryListTable"
        :data="newList"
        :columns="columnsData.columns"
        :pagination="false"
        :row-select="false"
        :row-action="true"
        row-key="inquiryid"
        :style="`width: ${columnsWidth > 1038 ? columnsWidth : 1038}px`"
        :event-config="eventConfig"
        @afterselect="afterselect"
        @change="handleChange"
        @onDragging="onDragging"
        @onDragstop="onDragstop"
      >
        <template
          slot="code"
          slot-scope="text, record, index"
          class="code btn"
        >
          <other-tooltip
            col-key="code"
            :text="text.code"
            :index="index"
            :columns="columnsData.columns"
          />
        </template>
        <template
          slot="base_info_info_level"
          slot-scope="text"
          class="info-level"
        >
          <a-rate
            v-if="parseInt(text.type) === 2"
            :default-value="text.info_level && text.info_level.fieldvalue"
            :count="text.level || 7"
            disabled
          >
            <i
              slot="character"
              class="iconfont iconicon-test6"
            />
          </a-rate>
          <span v-else>{{ info_level2(text.info_level && text.info_level.fieldvalue) }}</span>
        </template>
        <template
          slot="from_info"
          slot-scope="text, record, index"
          class="from-info"
        >
          <other-tooltip
            col-key="from_info"
            :text="setFromInfoText(text)"
            :index="index"
            :columns="columnsData.columns"
          />
        </template>
        <template
          slot="contact_info_company_name"
          slot-scope="text, record, index"
        >
          <other-tooltip
            col-key="contact_info_company_name"
            :text="text.fieldvalue"
            :index="index"
            :columns="columnsData.columns"
          />
        </template>
        <template
          slot="contact_info"
          slot-scope="text"
        >
          <contact-tooltip
            :text="text"
          />
        </template>
        <template
          slot="last_followup_time"
          slot-scope="text"
        >
          <followup-tooltip :text="text" />
        </template>
        <template
          slot="followup_remind_time"
          slot-scope="text"
        >
          <remind-tooptip :text="text" />
        </template>
        <template
          slot="base_info_info_type"
          slot-scope="text"
        >
          {{ text['info_type'].fieldvalue || '- -' }}
          <span
            v-if="text && text['info_sign'] && text['info_sign'].fieldvalue"
            class="beian-tag"
          >{{ text['info_sign'].fieldvalue }}</span>
        </template>
        <template
          slot="next_followup_time"
          slot-scope="text, record, index"
        >
          <!-- {{ text.next_followup_time || '- -' }} -->
          <other-tooltip
            col-key="next_followup_time"
            :text="text.next_followup_time || '- -'"
            :index="index"
            :columns="columnsData.columns"
          />
        </template>
        <template
          slot="dev_userid"
          slot-scope="text"
        >
          <a-tooltip
            overlay-class-name="td-userid-tooltip"
          >
            <span
              v-if="text.dev_truename"
              slot="title"
            >
              {{ text.dev_truename }}{{ text.dev_isread ? auditTit[0] : auditTit[1] }}
            </span>
            <i
              v-if="text.dev_truename"
              :class="['is-read', { 'no': !text.dev_isread, 'yes': text.dev_isread }]"
            />
            <span>{{ text.dev_truename || '- -' }}</span>
          </a-tooltip>
        </template>
        <template
          slot="follow_userid"
          slot-scope="text"
        >
          <a-tooltip
            overlay-class-name="td-userid-tooltip"
          >
            <span
              v-if="text.follow_truename"
              slot="title"
            >
              {{ text.follow_truename }}{{ text.follow_isread ? auditTit[0] : auditTit[1] }}
            </span>
            <i
              v-if="text.follow_truename"
              :class="['is-read', { 'no': !text.follow_isread, 'yes': text.follow_isread }]"
            />
            <span :class="{ 'fs-error': text.color_type === 1, 'fs-gray': text.color_type === 2 }">
              <!-- $color_type      = 0; //1红 2灰 -->
              <!-- follow_type 1共享 2待分配 3待指派 4分配到人 5已归档 -->
              <i v-if="text.follow_type === 1">[{{ $t('message["394"]') }}]</i>
              <i v-else-if="text.follow_type === 2">[{{ $t('message["139"]') }}]</i>
              <i v-else-if="text.follow_type === 3">[{{ $t('message["146"]') }}]</i>
              <i v-else-if="text.follow_type === 5">[{{ $t('message["1460"]') }}]</i>
              <i v-else>{{ text.follow_truename || '- -' }}</i>
            </span>
          </a-tooltip>
        </template>
        <span
          v-for="item in defineFieldTit"
          :key="item.fieldkey"
          :slot="item.fieldkey"
          slot-scope="text, record, index"
        >
          <other-tooltip
            :col-key="item.fieldkey"
            :text="text"
            :index="index"
            :columns="columnsData.columns"
          />
        </span>
      </data-table>
    </div>
    <pagination
      v-if="newList && newList.length"
      ref="pagination"
      :pagination="pagination"
      @change="handlePage"
    />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'
import { getEncode } from '@/lib/mix'
import { setCodeData, base64ToJson } from '@/lib/utils'
// import { setStorage, getStorage, clearStorage } from '@/lib/storage'
import { DataTable } from '@/components/pc/dataTable/index.js'
import Pagination from '@/components/pc/Pagination'
import ContactTooltip from './../tooltip/ContactTooltip'
import FollowupTooltip from './../tooltip/FollowupTooptip'
import OtherTooltip from './../tooltip/OtherTooltip'
import RemindTooptip from './../tooltip/RemindTooptip'
import eventBus from '@/lib/eventBus'

export default {
  components: {
    DataTable,
    Pagination,
    ContactTooltip,
    FollowupTooltip,
    OtherTooltip,
    RemindTooptip
  },
  props: {
    from: {
      type: String,
      default: ''
    },
    type: {
      type: [String, Number],
      default: ''
    },
    paramsType: {
      type: [String, Number],
      default: ''
    },
    fieldkey: {
      type: String,
      default: ''
    },
    fieldvalue: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      // filterStr: '',
      // filters: {}
      columnsWidth: 0,
      eventConfig: {
        tabToActive: true, // Tab键进入下一个单元格编辑
        enterToActive: true, // 回车键进入下一个单元格编辑
        rightArrowToActive: true, // 向右箭头激活同一行下一列的编辑
        leftArrowToActive: true, // 向左箭头激活同一行前一列的编辑
        upArrowToActive: true, // 向上箭头激活上一行相同列的编辑
        downArrowToActive: true, // 向下箭头激活下一行相同列的编辑
        resizeableColumn: true, // 列宽拖拽调整,设为true的话，column必须设宽度值，且为整数，如：width:100
        resizeableColumnMinWidth: 88
      },
      tableScroll: {
        left: 0
      }
    }
  },
  computed: {
    ...mapState(['menuDatas']),
    ...mapState('inquery/listData', [
      'loading',
      'list',
      'pagination',
      'tableSort'
    ]),
    ...mapState('inquery/filterData', ['filterStr']),
    ...mapGetters('inquery/listData', [
      'columnsData',
      'newList',
      'defineFieldTit'
    ]),
    pid () {
      return this.$route.params.pid
    },
    filters () {
      let filters = {}
      if (this.filterStr) {
        filters = base64ToJson(this.filterStr)
        // 将结果放到store
        this.setFilterResult(filters)
      } else {
        this.setFilterResult({})
      }

      return filters
    },
    currentPage () {
      const { page = 1 } = this.$route.query
      return parseInt(page)
    },
    pageSize () {
      const { limit = 10 } = this.$route.query
      return parseInt(limit)
    },
    sorttype () {
      return parseInt(this.$route.query.sorttype) || 0
    },
    sortkey () {
      return this.$route.query.sortkey
    },
    viewid () {
      return this.$route.query.viewid
    },
    issystem () {
      return this.$route.query.issystem
    },
    auditTit () {
      return this.$t('message["1451"]').split('|')
    }
  },
  watch: {
    type (val) {
      this.pagination.currentPage = 1
      this.pagination.pageSize = 10
      this.setFilterStr('')
      this.setFilterResult({})
      this.tableScroll.left = 0
    },
    $route (to, from) {
      this.pagination.currentPage = this.currentPage
      this.pagination.pageSize = this.pageSize
      if (!to.query._t) {
        this.setFilterStr('')
        this.setFilterResult({})
        this.tableScroll.left = 0
      }
      if (this.fieldvalue === '') {
        this.$emit('clearSearchConfig')
      }
      this.fetchData()
    }
  },
  created () {
    this.pagination.currentPage = this.currentPage
    this.pagination.pageSize = this.pageSize
    this.fetchData()
    eventBus.$on('fetchInquiryList', this.fetchData)
  },
  beforeDestroy () {
    eventBus.$off('fetchInquiryList', this.fetchData)
  },
  mounted () {
    this.tableScroll.left = 0
  },
  methods: {
    ...mapMutations('inquery/listData', ['SET_TABLE_SORT', 'SET_PAGINATION']),
    ...mapActions('inquery/listData', ['fetchList', 'setInquiryListWidth']),
    ...mapActions('inquery/filterData', ['setFilterResult', 'setFilterStr']),

    async fetchData (obj = {}) {
      let isFilter = false
      let params = {}
      let tableSort = this.tableSort
      let { fieldkey, fieldvalue, viewid, issystem } = this

      params.scope = this.from
      params.type = this.paramsType
      params.page = this.pagination.currentPage
      params.limit = this.pagination.pageSize
      // params.code = this.code
      if (fieldvalue) {
        const enCode = await getEncode()
        params.fieldkey = fieldkey
        params.fieldvalue = await setCodeData(fieldvalue, enCode)
      }
      if (viewid) {
        params.viewid = viewid
        params.issystem = issystem
      }

      'sortkey' in tableSort && Object.assign(params, { sortkey: tableSort.sortkey })
      'sorttype' in tableSort && Object.assign(params, { sorttype: tableSort.sorttype })
      'sortfieldtype' in tableSort && Object.assign(params, { sortfieldtype: tableSort.sortfieldtype })

      if (this.filterStr) {
        params.search = await this.setFilterRequestParams(this.filters)
        isFilter = true
      } else {
        isFilter = false
      }

      const chain = await this.fetchList({ isFilter, viewid })
      chain
        .params({ ...params, ...obj })
        .onSuccess(res => {
          if (!isFilter && !this.fieldvalue) {
            this.SET_PAGINATION({
              allCount: res.data && res.data.count
            })
          }
          this.setTitle()
          this.setTableWidth()
          this.setScrollLeft()
        })
        .fetch()
    },

    setTitle () {
      const { permissionMenuList = {} } = this.menuDatas
      let parent = {}
      if (this.from === 'my') {
        parent = permissionMenuList['inquiry-mine'] || {}
      } else if (this.from === 'all') {
        parent = permissionMenuList['inquiry-all'] || {}
      }
      let { child = {} } = parent
      let { name = '' } = child[this.type] || {}
      document.title = name + '-' + this.$store.state.baseinfo.projectname + '-' + this.$store.state.baseinfo.comname
    },

    setTableWidth () {
      this.columnsWidth = this.columnsData.width > 1038 ? this.columnsData.width : 1038
    },

    /* 获取表格滚动条距离 */
    getScrollDis () {
      let $table = document.querySelector('.inquiry-table')
      this.tableScroll.left = $table && $table.scrollLeft
    },
    setScrollLeft () {
      let $table = document.querySelector('.inquiry-table')
      let left = this.tableScroll.left
      if ($table) {
        $table.scrollLeft = left
      }
    },

    // 点击筛选的确定按钮时，处理数据为 key: value 格式
    async setFilterRequestParams (filter) {
      let obj = {}
      const enCode = await getEncode()
      for (let fieldkey in filter) {
        const item = filter[fieldkey]
        switch (item.fieldtype) {
          case 'text':
          case 'phone':
          case 'email':
          case 'editor':
          case 'tag':
            // console.log('fieldname: ', item.fieldname, item.fieldvalue)
            obj[fieldkey] = await setCodeData(item.fieldvalue, enCode)
            // console.log('value: ', item.fieldvalue)
            break
          case 'area':
            obj[fieldkey] = item.fieldvalue && Object.keys(item.fieldvalue)
            break
          case 'select_tree':
            obj[fieldkey] = item.fieldvalue && Object.keys(item.fieldvalue)
            break
          case 'from_info':
            let { fieldvalue = [] } = item

            let arr = []
            for (let i in fieldvalue) {
              let fields = fieldvalue[i] || []

              let one = {}
              let len = fields.length

              if (len === 1) {
                one['from_info.from'] = fields[0].fieldkey
              } else if (len === 2) {
                let fieldItem = fields[1] || {}
                one[fieldItem.fieldkey] = fields[1].inputVal
              } else if (len === 3) {
                let fieldItem = fields[1] || {}
                one[fieldItem.fieldkey] = fields[2].id
              }
              if (Object.keys(one).length) {
                arr.push(one)
              }
            }

            obj[fieldkey] = arr
            break
          case 'selectrolegroup':
          case 'selectuser':
            let res = item.fieldvalue || []
            for (let j in res) {
              let one = res[j]
              for (let k in one) {
                if (k === '_id') {
                  delete one[k]
                }
              }
            }
            obj[fieldkey] = res
            break
          case 'selectfollowuser':
          case 'selectinputuser':
            let values = item.fieldvalue || {}
            let users = values[fieldkey] || []
            for (let j in users) {
              let one = users[j]
              for (let k in one) {
                if (k === '_id') {
                  delete one[k]
                }
              }
            }
            obj[fieldkey] = values
            break
          case 'radioinfo_type':
            obj['base_info.info_sign'] = item.info_sign
            obj[fieldkey] = item.fieldvalue
            break
          default:
            obj[fieldkey] = item.fieldvalue
            break
        }
      }
      // console.log(obj)
      return obj
    },
    afterselect (ids, rows) {
      this.handlerDetail(rows)
    },
    handlerDetail (record) {
      this.$router.push({
        name: record.status === 1 ? 'InqueryPassDetail' : 'InqueryDetail',
        params: {
          pid: this.pid,
          inquiryId: record.inquiryid
        },
        query: {
          ...this.$route.query,
          from: this.from
        }
      })
    },

    handlePage (pagination) {
      this.getScrollDis()
      this.pagination.currentPage = pagination.currentPage
      this.$router.push({
        query: {
          ...this.$route.query,
          page: pagination.currentPage,
          limit: pagination.pageSize,
          ...this.tableSort,
          _t: new Date().getTime()
        }
      })
    },
    // table表排序变化操作
    handleChange (pagination, filters, sorter) {
      this.getScrollDis()
      // console.log(pagination, filters, sorter)
      this.pagination.currentPage = 1
      if (sorter.order) {
        let sort = 0
        if (sorter.order === 'ascend') {
          sort = 1 // 正序
        } else if (sorter.order === 'descend') {
          sort = 2 // 倒序
        } else {
          sort = 0
        }
        // console.log(sorter)
        const tableSort = {
          sortkey: sorter.column.sortkey,
          sorttype: sort,
          sortfieldtype: sorter.column.fieldtype
        }
        // this.fetchData(tableSort)
        this.SET_TABLE_SORT({ tableSort, sorter })

        this.$router.push({
          query: {
            ...this.$route.query,
            page: this.pagination.currentPage,
            limit: this.pagination.pageSize,
            ...tableSort,
            _t: new Date().getTime()
          }
        })
      } else {
        // this.fetchData({})
        let tableSort = {
          sortkey: '',
          sorttype: 0,
          sortfieldtype: ''
        }
        this.SET_TABLE_SORT({ tableSort: {}, sorter: {} })
        this.$router.push({
          query: {
            ...this.$route.query,
            page: this.pagination.currentPage,
            limit: this.pagination.pageSize,
            ...tableSort,
            _t: new Date().getTime()
          }
        })
      }
    },
    info_level2 (val) {
      let newVal
      ['A', 'B', 'C', 'D', 'E', 'F', 'G'].forEach((item, index) => {
        if (val - 1 === index) {
          newVal = item
        }
      })
      return newVal || '--'
    },
    setRowClassName (record, index) {
      return !record.isread ? 'is-read' : ''
    },
    setFromInfoText (text) {
      let str = ''
      if (text.from.fieldvalue && text.from_detail.fieldvalue) {
        str = `${text.from.fieldvalue} | ${text.from_detail.fieldvalue}`
      } else if (text.from.fieldvalue) {
        str = `${text.from.fieldvalue}`
      } else if (text.from_detail.fieldvalue) {
        str = `${text.from_detail.fieldvalue}`
      } else {
        str = '- -'
      }
      return str
    },
    onDragging (col, disX) {
      this.columnsWidth += disX
      // console.log(disX, this.columnsWidth)
    },
    async onDragstop (data, colWidth, key) {
      // console.log(data, colWidth, key)

      let params = {
        scope: this.from,
        type: this.paramsType,
        config: {}
      }

      params.config[key] = colWidth
      await this.setInquiryListWidth(params)
      let $dragEles = document.querySelectorAll('.table-draggable-handle')
      $dragEles.forEach((ele) => {
        ele.className = 'draggable vdr table-draggable-handle'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.inquiry-table::v-deep {
  overflow-x: auto;
  word-break: break-all;
  margin-top: 24px;
  .ant-table-empty .ant-table-body {
    overflow: hidden !important;
  }
  .ant-table-body {
    // width: 100%;
    table {
      table-layout: fixed;
      width: 100%;
    }
  }

  .demand-info-title {
    display: block;
    width: 232px;
    white-space: normal;
  }
  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    position: relative;
    padding: 12px 15px;
  }
  .ant-table-tbody > tr {
    cursor: pointer;
  }

  .ant-table-tbody > tr > td {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    > div {
      display: block;
    }
  }
  .ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-sorters, .ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-filters {
    padding-right: 15px !important;
  }
  .ant-rate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }
  td .is-read {
    display: inline-block;
    position: relative;
    font-size: 0;
    transform: scale(0.5);
    transform-origin: center left;
    &.no {
      width: 16px;
      height: 16px;
      vertical-align: middle;
      border-radius: 8px;
      background: #4CA0F2;
    }
    &.yes {
      width: 16px;
      height: 16px;
      vertical-align: middle;
      border-radius: 8px;
      background: #D6D6D6;
    }
  }
  td .is-read + span {
    margin-left: -4px;
    vertical-align: middle;
  }
}
.ant-table-wrapper {
  padding-top: 24px;
  td {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }
}

i,
em {
  font-style: normal;
}
::v-deep .ant-table-tbody > tr.is-read {
  td,
  span,
  i,
  .contact-content {
    font-weight: 600;
  }
}
.beian-tag {
  display: inline-block;
  padding: 2px 4px;
  line-height: 1;
  color: #666;
  font-size: 12px;
  border: solid 1px #EBEBEB;
  border-radius: 4px;
}
</style>
<style lang="scss">
  .td-userid-tooltip{
    .ant-tooltip-inner {
      padding: 16px;
      font-size: 14px;
      color: #333;
    }
    .ant-tooltip-arrow {
      display: none;
    }
  }
</style>
